export default "__VITE_ASSET__5d3eeb1f__"